import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* contractChangeIsCommercial(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `contract/${action.payload?.contractId}/commercial`, {
      isCommercial: action.payload?.isCommercial
    });

    yield put({
      type: Constants.GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractChangeIsCommercial() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_START, contractChangeIsCommercial);
}
